import { makeStyles } from '@material-ui/core/styles'
import NoQuoteSadImage from 'src/assets/Buy_Policy_Images/NoQuoteSadImage.svg'

const EmptyInsuranceDetails = () => {
  const classes = useStyles()
  return (
    <>
      <div className={classes.noDetailsContainer}>
        <img
          src={NoQuoteSadImage}
          alt='Not Found'
          className={classes.notFoundImage}
        />
        <span className={classes.notFoundText}>
          No Policies found for the provided details.
        </span>
      </div>
    </>
  )
}

export default EmptyInsuranceDetails

export const useStyles = makeStyles({
  noDetailsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '30px',
    gap: '10px',
  },
  notFoundImage: {
    width: '100%',
    height: '100%',
    maxHeight: '200px',
    maxWidth: '200px',
  },
  notFoundText: {
    fontSize: '20px',
    fontStyle: 'italic',
    opacity: '50%',
    fontWeight: 'bold',
  },
})
